import React, { useState } from 'react';
import { notification } from 'antd'; // Import notification

export const SubscribeSalesforce = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        source: '', // For the select dropdown
        otherSource: '', // For the "Other" input field
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    // Removed errorMessage state as we'll use notifications

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setIsSubmitting(true);

        // Get the final source value based on selection
        const finalSource = formData.source === 'Other' ? formData.otherSource : formData.source;

        // Basic validation
        if (!formData.firstName || !formData.lastName || !formData.email || !finalSource) {
            notification.error({
                message: 'Submission Failed',
                description: 'Please fill out all required fields.',
                placement: 'topRight',
            });
            setIsSubmitting(false);
            return;
        }

        const pardotUrl = "https://info.gnomon.edu/l/1046603/2025-04-08/yw82";

        // Prepare data in the format Pardot expects (usually URL-encoded)
        const body = new URLSearchParams();
        body.append('formid', '1046603'); // Ensure hidden fields are included
        body.append('return_url', typeof window !== 'undefined' ? window.location.href : '');
        body.append('error_url', typeof window !== 'undefined' ? window.location.href : '');
        // Map state keys to Pardot field names (case-sensitive)
        body.append('First Name', formData.firstName);
        body.append('Last Name', formData.lastName);
        body.append('email', formData.email);
        // Try using the exact field name from Pardot configuration
        body.append('Web_Newsletter_Source', finalSource);
        // Also include the Salesforce field name as a hidden field
      // body.append('Web_Newsletter_Source', finalSource);

      body.append('utm_campaign', 'Gnomon Newsletter');
      body.append('utm_medium', 'Email');
      body.append('utm_source', 'Source');

        try {
            const response = await fetch(pardotUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: body.toString(),
                mode: 'no-cors' // IMPORTANT: Pardot often requires 'no-cors' for client-side submissions, which means you won't be able to read the response body directly. Success is inferred if no network error occurs.
            });

            // Since mode is 'no-cors', we can't check response.ok or read the body.
            // Assume success if the fetch itself didn't throw an error.
            notification.success({
                message: 'Submission Successful',
                description: 'Thank you for subscribing!',
                placement: 'topRight',
            });
            // Optionally reset the form
            setFormData({ firstName: '', lastName: '', email: '', source: '', otherSource: '' });

        } catch (error) {
            console.error('Form submission error:', error);
            notification.error({
                message: 'Submission Failed',
                description: 'An error occurred while submitting the form. Please try again.',
                placement: 'topRight',
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="_rel" style={{ marginBottom: '4em', width: '100%' }}>
            <div className="subscribe-form0  angle8">
                <form
                    id="pardot-form"
                    onSubmit={handleSubmit}
                    className="subscribe-form _f _fwrap _fcc"
                >
                    <div className="form-group">
                        <label htmlFor="first_name">First Name *</label>
                        <input
                            type="text"
                            id="first_name"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="last_name">Last Name *</label>
                        <input
                            type="text"
                            id="last_name"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Email *</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="form-group _fv _fm _f100">
                        <label htmlFor="source">How did you hear about Gnomon? *</label>
                        <select
                            id="source"
                            name="source"
                            value={formData.source}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        >
                            <option value="">Select an option</option>
                            <option value="Website/Search">Website/Search</option>
                            <option value="Social Media">Social Media</option>
                            <option value="Magazine/Publication">Magazine/Publication</option>
                            <option value="Gnomon Event">Gnomon Event</option>
                            <option value="Conference/Trade Show">Conference/Trade Show</option>
                            <option value="Personal Referral">Personal Referral</option>
                            <option value="School Presentation">School Presentation</option>
                            <option value="TV/Radio">TV/Radio</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>

                    {formData.source === 'Other' && (
                        <div className="form-group _fv _fm _f100">
                            <label htmlFor="otherSource">Please specify</label>
                            <input
                                className="input-specify"
                                type="text"
                                id="otherSource"
                                name="otherSource"
                                value={formData.otherSource}
                                onChange={handleChange}
                                required
                                disabled={isSubmitting}
                            />
                        </div>
                    )}

                    <div className="form-group _f100 _fc">
                        <button type="submit" className="button-gnomon" disabled={isSubmitting}>
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                    </div>
                </form>
                <br />
            </div>
            <div className="subscribe-form-border ybg angle8 _f100" />
        </div>
    );
};

